import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface jumpingStore {
  jumpSpeed: number; // 打字机速度
  jumpedText: string; // 打过的文字
  jumpingTextControl: any; // 控制打字机销毁
  targetJumpIndex: number; // 当前打到第几个index
}

const initialState: jumpingStore = {
  jumpSpeed: 60,
  jumpedText: '',
  targetJumpIndex: 0,
  jumpingTextControl: null,
};

export const jumpingSlice = createSlice({
  name: 'audio',
  initialState,
  reducers: {
    clearJumpingStore: (state) => {
      return {
        ...state,
        jumpingTextControl: null,
        jumpedText: '',
        targetJumpIndex: 0,
      };
    },
    onSetJumpedText: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        jumpedText: action.payload,
        targetJumpIndex: action.payload?.length,
      };
    },
    setJumpingTextControl: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        jumpingTextControl: action.payload,
      };
    },
    setJumpSpeed: (state, action: PayloadAction<number>) => {
      state.jumpSpeed = action.payload;
    },
  },
});

export const { onSetJumpedText, clearJumpingStore, setJumpingTextControl, setJumpSpeed } =
  jumpingSlice.actions;

export default jumpingSlice.reducer;
